import { Component, Input, OnChanges, SimpleChanges, inject, DestroyRef, ChangeDetectorRef } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { EngagementService } from 'src/app/shared/services/engagement/engagement.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EngagementCardsComponent } from '../engagement-lite/components/engagement-cards/engagement-cards.component';
import { NgIf, NgClass } from '@angular/common';
import { EngagementRecordsSummaryDrilldownComponent } from './components/engagement-records-summary-drilldown/engagement-records-summary-drilldown.component';
import { EngagementChannelPerformanceComponent } from './components/engagement-channel-performance/engagement-channel-performance.component';

@Component({
    selector: 'app-engagement-summary',
    templateUrl: './engagement-summary.component.html',
    styleUrl: './engagement-summary.component.scss',
    imports: [EngagementCardsComponent, NgIf, EngagementRecordsSummaryDrilldownComponent, NgClass, EngagementChannelPerformanceComponent]
})
export class EngagementSummaryComponent implements OnChanges {
  @Input() isDeviationEnabled = false;

  private dataSubscription?: Subscription;
  isDataAvailable: boolean = false;
  isDataLoaded: boolean = false;
  dates = {
    startDate: '',
    endDate: ''
  };
  overall_summary = [];
  distributionData: any;
  errorCode: string = '404';
  restrictToday: boolean = false;
  displayName: string = "";
  brandName: string = "";
  accountName: string = "";
  hierarchyName: string = "";
  destroyRef = inject(DestroyRef);
  constructor(
    private helpersService: HelpersService,
    private engagementService: EngagementService,
    private cdRef: ChangeDetectorRef) {
    this.helpersService.datePicker.subscribe(data => {
      if (data) {
        this.dates.startDate = data.startDate;
        this.dates.endDate = data.endDate;
      }
    })
  }

  recordsJourneyData = {
    current: {
      number_of_request_generated_rated: 0,
      number_of_unique_requests_delivered: 0,
      number_of_request_generated: 0
    }
  }
  isLeftCardVisible: boolean = true;

  ngOnInit() {

    this.initializecomponent()
  }

  initializecomponent() {
    this.helpersService.appState.subscribe(
      (response: any) => {
        if (response && !response.pending) {
          this.recordsJourneyData = {
            current: {
              number_of_request_generated_rated: 0,
              number_of_unique_requests_delivered: 0,
              number_of_request_generated: 0
            }
          }

          this.isDataLoaded = false;
          this.isDataAvailable = true;
          // trend details :- RR trend and Request trend
          // this.getOverallSummary(1, 'trend', this.dates, null, true, true);
          // Records Journey
          this.restrictToday = !this.engagementService.is_valid_date_range(this.dates.endDate, this.dates.startDate)
          this.cdRef.detectChanges();
          this.displayName = this.engagementService.getDisplayName();
          this.getOverallSummary(2, 'summary', this.dates, null, "overall");
          // Response distribution not required in lite
          // this.getOverallSummary(3, 'summary', this.dates, null, false, false);
          // this.getOverallSummary()
          this.brandName = response.brandDetails ? response.brandDetails.name : ''

          let hierarchyOptions: any[] = [];
          if (this.brandName) {
            var hierarchyStack = response.hierarchyStack ? Helpers.hierarchyStack : [];
            var hierarchyList = _.cloneDeep(Helpers.brandDetails.hierarchy_list);
            var hierarchyAlias = _.cloneDeep(Helpers.brandDetails.hierarchy_list_alias);
            var key = _.find(Object.keys(hierarchyAlias), function (data) {
              return (data != 'default')
            });

            if (hierarchyList && hierarchyList[key] && hierarchyList[key].length > 1) {
              hierarchyOptions = [{
                "name": "Hierarchy",
                "view_type": "hr"
              }];
              if (hierarchyStack && hierarchyStack.length) {
                var alias = _.sortBy(hierarchyStack, ["field_id"])
                var alias_name = alias[alias.length - 1]
                this.hierarchyName = alias_name.group_key[0]
              }
            }
          } else {
            this.accountName = response.accountDetails.name;
          }
        }
      }

    )
  }

  getOverallSummary(
    query_type: any,
    view_type: any,
    dates: { startDate: string; endDate: string; },
    trend_data: any,
    chart_type: string
  ) {
    const formatDate = (date: Date): string => {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return `${year}${month}${day}`;
    };

    var params = this.engagementService.getSummaryParams({
      "rater_type": 3,
      "query_type": query_type,
      "view_type": view_type,
      "dates": dates,
      "trend_type": (trend_data && trend_data.value) ? trend_data.value : 2,
      "is_deviation_enabled": query_type === 2 ? this.isDeviationEnabled : undefined,
    })
    // this.isDataLoaded = false;
    // this.isDataAvailable = false;
    // this.isBarChartLoaded = false;
    if (dates.startDate == dates.endDate) {
      params.trend_type = 0;
    }
    this.dataSubscription = this.engagementService.getEngagementSummary(params).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (response) => {
        if (response &&
          response.code == 0 &&
          response.data.overall_summary_details &&
          (response.data.overall_summary_details &&
            Object.keys(response.data.overall_summary_details).length > 0)) {
          this.isDataAvailable = true;
          if (params["view_type"] === 'trend') {
            this.overall_summary = response.data.overall_summary_details.trends
            var trend_name = (trend_data && trend_data.name) ? trend_data.name : ''
            this.isDataAvailable = true;
          }
          if (params["view_type"] === 'summary' && params["query_type"] === 2) {
            this.recordsJourneyData = response.data.overall_summary_details.summary;
            // this.prepareDataForRequestJourney(this.recordsJourneyData)
            this.isDataAvailable = true;
            // this.isDataLoaded = true;
          }
          if (params["view_type"] === 'summary' && params["query_type"] === 3) {
            this.distributionData = response.data.overall_summary_details.summary;
            this.isDataAvailable = true;
            // this.isDataLoaded = true;
          }
          this.isDataLoaded = true;
        } else {
          this.isDataAvailable = false;
          this.isDataLoaded = true;
          this.errorCode = '404'
        }
      },
      error: (err) => {
        this.isDataAvailable = false
        this.isDataLoaded = true;
        if (err.status == '500') {
          this.errorCode = '500'
        } else if (err.status == "408") {
          this.errorCode = '408'
        }
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isDeviationEnabled'] && !changes['isDeviationEnabled'].firstChange && this.dates?.startDate) {
      this.getOverallSummary(2, 'summary', this.dates, null, 'overall');
    }
  }
}
